import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)
const routes = [
    {
        path: "/",
        name: "root",
        component: () => import("../views/ViewLanguage")
    },
    {
        path: "/welcome",
        name: "welcome",
        component: () => import("../views/ViewWelcome")
    },
    {
        path: "/instructions",
        name: "instructions",
        component: () => import("../views/ViewInstructions")
    },
    {
        path: "/tan",
        name: "tan",
        component: () => import("../views/ViewTan")
    },
    {
        path: "/register",
        name: "register",
        component: () => import("../views/ViewRegister")
    },
    {
        path: "/vip",
        name: "vip",
        component: () => import("../views/ViewVip")
    },
    {
        path: "/result",
        name: "result",
        component: () => import("../views/ViewResult")
    },
    {
        path: "/end",
        name: "end",
        component: () => import("../views/ViewEnd")
    },
    {
        path: "/error",
        name: "error",
        component: () => import("../views/ViewError")
    },
    {
        path: "/notfound",
        name: "notfound",
        component: () => import("../views/ViewNotFound")
    },
    {
        path: "/notsupported",
        name: "notsupported",
        component: () => import("../views/ViewNotSupported")
    }
]

const router = new VueRouter({
    routes,
    mode: "abstract",
})

export default router